import './header.scss'
import { Link, useNavigate } from 'react-router'
import { useAuth } from 'src/utils/Hooks/useAuth'
import { logOut } from 'src/redux/Slices/authSlice'
import { useDispatch } from 'react-redux'
import SpriteSvg from '../SpriteSvg'
import { useLogOutMutation } from 'src/redux/Api/authApi'
import Input from 'src/Components/Form/Input'
import { useEffect, useState } from 'react'
import { motion } from 'framer-motion'
import IconChevronDown from 'src/assets/img/icons/chevron-down.svg'

const LogOutButton = () => {
  const dispatch = useDispatch()
  const [logout] = useLogOutMutation()
  const navigate = useNavigate()
  const logOutHandler = () => {
    logout()
    dispatch(logOut())
    navigate('/login', { replace: true })
  }
  return (
    <span className="log_out" onClick={logOutHandler}>
      Log Out
    </span>
  )
}

const AccountMenu = () => {
  const [showAccountMenu, setShowAccountMenu] = useState(false)

  useEffect(() => {
    document.addEventListener('click', (e) => {
      if (e.target instanceof HTMLElement && !e.target.closest('.account_menu') && !e.target.closest('.chevron')) {
        setShowAccountMenu(false)
      }
    })
  }, [])

  return (
    <>
      <img
        src={IconChevronDown}
        alt="chevron"
        className={showAccountMenu ? 'chevron active' : 'chevron'}
        onClick={() =>
          setShowAccountMenu((prev) => {
            return !prev
          })
        }
      />
      {showAccountMenu && (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.2 }}
          className="account_menu"
        >
          <Link to="/profile">Profile</Link>
          <LogOutButton />
        </motion.div>
      )}
    </>
  )
}

const Header = () => {
  const { id, avatar, name } = useAuth()
  const [search, setSearch] = useState('')

  const getInitials = (name: string) => {
    if (name === null) {
      return ''
    }
    let initials = name.split(' ')[0][0]

    if (name.split(' ').length > 1) {
      initials += name.split(' ')[1][0]
    }
    return initials
  }

  return (
    <header>
      <Input value={search} onChange={(e) => setSearch(e.target.value)} label="Search" />
      <div className="account">
        {id ? (
          <>
            <div className="avatar">
              {avatar !== null && avatar !== '' ? (
                <img src={avatar} alt="avatar" />
              ) : name ? (
                <span className="initials">{getInitials(name)}</span>
              ) : (
                <SpriteSvg id="profile" />
              )}
            </div>
            <p>{name}</p>
            <AccountMenu />
          </>
        ) : (
          <>
            <Link className="btn" to="/login">
              Login
            </Link>
            <Link className="btn green" to="/sign-up">
              Sign Up
            </Link>
          </>
        )}
      </div>
    </header>
  )
}

export default Header
